import axios from 'axios'
import Cookies from "js-cookie"

export const supportPhoneNumber = '5511966466526'

export function searchPostalCode(CEP, payload, errorPayload = () => { }) {
    axios.get(`https://viacep.com.br/ws/${CEP}/json/`)
        .then(resp => {
            payload(resp.data)
        })
        .catch(error => errorPayload(error))
}
export async function viaCep(cep) {
    return axios.get(`https://viacep.com.br/ws/${cep}/json/`)
}
export async function receitaws(cnpj) {
    //https://receitaws.com.br/v1/cnpj/83325498000190
    return axios.get(`https://receitaws.com.br/v1/cnpj/${cnpj}`)
}
export function validateCPF(cpf) {
    if(typeof cpf !== "string") return false
    cpf = cpf.replace(/[^\d]/g, ''); // Remove caracteres não numéricos
    if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;

    let soma = 0, resto;
    for (let i = 1; i <= 9; i++) soma += parseInt(cpf[i - 1]) * (11 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf[9])) return false;

    soma = 0;
    for (let i = 1; i <= 10; i++) soma += parseInt(cpf[i - 1]) * (12 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    return resto === parseInt(cpf[10]);
}
export function sanitizeCNPJ(cnpj) {
    if (typeof cnpj !== "string") return "";
    return cnpj.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
}

export function validateCNPJ(cnpj) {
    if (typeof cnpj !== "string") return false;
    const clean = cnpj.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();

    // O CNPJ deve possuir 14 caracteres: 12 alfanuméricos e 2 dígitos verificadores numéricos
    if (clean.length !== 14 || !/^[A-Z0-9]{12}[0-9]{2}$/.test(clean)) {
        return false;
    }

    // Rejeita sequências com todos os 14 caracteres idênticos (ex: 00000000000000, AAAAAAAAAAAAAA)
    if (/^(.)\1{13}$/.test(clean)) {
        return false;
    }

    // Conversão oficial da Receita Federal: ASCII - 48
    // Números '0'-'9' (48-57) -> 0 a 9
    // Letras 'A'-'Z' (65-90) -> 17 a 42
    const getCharValue = (c) => c.charCodeAt(0) - 48;

    const weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const weights2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

    let sum1 = 0;
    for (let i = 0; i < 12; i++) {
        sum1 += getCharValue(clean[i]) * weights1[i];
    }
    const rest1 = sum1 % 11;
    const dv1 = rest1 < 2 ? 0 : 11 - rest1;

    if (parseInt(clean[12], 10) !== dv1) {
        return false;
    }

    let sum2 = 0;
    for (let i = 0; i < 12; i++) {
        sum2 += getCharValue(clean[i]) * weights2[i];
    }
    sum2 += dv1 * weights2[12];

    const rest2 = sum2 % 11;
    const dv2 = rest2 < 2 ? 0 : 11 - rest2;

    return parseInt(clean[13], 10) === dv2;
}

export function formatDocument(document = "") {
    if (!document) {
        return "";
    }
    const str = String(document).trim();
    if (str.length === 11) {
        return str.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
    } else if (str.length === 14) {
        return str.toUpperCase().replace(/([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([0-9]{2})/g, "$1.$2.$3/$4-$5");
    }
    return str;
}
export function validatePhone(phoneNumber) {
    return (/^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][0-9])\)?\s?)(?:((?:9\d|[2-9])\d{3})\-?(\d{4}))$/).test(phoneNumber)
}
export function validateEmail(email) {
    return (/^[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/).test(email)
}
export function formatPhoneNumber(phone = "") {
    if (phone.length === 10) {
        return phone.replace(/(\d{2})(\d{4})(\d{4})/g, "($1) $2-$3")
    } else if (phone.length === 11) {
        return phone.replace(/(\d{2})(\d{5})(\d{4})/g, "($1) $2-$3")
    }
}
export function formatCurrencyValue(value = "") {
    if (value === undefined || value === null) {
        return
    }
    return value.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    })
}
export function decimalFormat(double = 0, precision = 4) {
    if (double === null || double === undefined || isNaN(Number(double))) {
        return 0;
    }
    const num = Number(double);
    const factor = Math.pow(10, precision);
    return Math.round((num + Number.EPSILON) * factor) / factor;
}
export function formatDate(datetime, withDatetime = true) {
    if (withDatetime) {
        const options = {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
        };
        return new Date(datetime).toLocaleDateString('pt-BR', options)
    } else {
        return new Date(datetime).toLocaleDateString('pt-BR')
    }

}
export function donwloadBase64(filename, fileExtersion, mimeType, data) {
    const LinkSource = `data:${mimeType};base64,${data}`;
    const DownloadLink = document.createElement('a');
    DownloadLink.href = LinkSource;
    DownloadLink.download = `${filename}.${fileExtersion}`;
    DownloadLink.click();
}
export function getCookieByName(name) {
    return Cookies.get(name)
}
export function setCookieByName(name, value) {
    Cookies.set(name, value, { secure: true, expires: 365 })
}
export function clearAllCookies() {
    for (let k of Object.keys(Cookies.get())) {
        if (k !== "easygestor_hide_startup_awards_banner_2026") {
            Cookies.remove(k)
        }
    }
}
export function checkIfBranchExists() {
    let branch = window.localStorage.getItem("easygestorweb_current_branch")
    if (branch) {
        branch = JSON.parse(branch || {})
        if (branch.id === "09ef7488-d439-40da-b384-5ccde14ffe8a") {
            window.location.href = "/branches/create"
        }
    } else {
        window.location.href = "/branches/create"
    }
}
export function setLocalStorageItem(key, value, stringfy = true) {
    try {
        // Verifica se localStorage está disponível
        if (typeof window === 'undefined' || !window.localStorage) {
            throw new Error("localStorage não está disponível")
        }
        
        // Modifica a key se estiver em desenvolvimento
        if (process.env.NODE_ENV === "development") {
            key = `${process.env.NODE_ENV}:${key}`
        }
        
        // Converte para string se necessário
        let finalValue = value
        if (stringfy) {
            try {
                finalValue = JSON.stringify(value)
            } catch (stringifyError) {
                throw new Error(`Erro ao converter valor para JSON: ${stringifyError.message}`)
            }
        }
        
        window.localStorage.setItem(key, finalValue)
        
        // Verifica se foi realmente salvo
        const verification = window.localStorage.getItem(key)
        if (verification === null) {
            // silently ignore — pode ser bloqueio de storage em modo privado
        }
        
        return true
        
    } catch (error) {
        // Verifica se é erro de quota excedida
        if (error.name === 'QuotaExceededError' || error.code === 22) {
            console.error("[setLocalStorageItem] Quota do localStorage excedida")
        }
        
        throw error
    }
}

export function getLocalStorageItem(key = "", parse = true) {
    try {
        // Verifica se localStorage está disponível
        if (typeof window === 'undefined' || !window.localStorage) {
            return null
        }
        
        // Modifica a key se estiver em desenvolvimento
        if (process.env.NODE_ENV === "development") {
            key = `${process.env.NODE_ENV}:${key}`
        }
        
        let data = window.localStorage.getItem(key)
        
        if (data === null) {
            return null
        }
        
        // Parse do JSON se necessário
        if (data && parse) {
            try {
                return JSON.parse(data)
            } catch (parseError) {
                return data
            }
        }
        
        return data
        
    } catch (error) {
        return null
    }
}

export function deleteLocalStorageItem(key = "") {
    try {
        // Verifica se localStorage está disponível
        if (typeof window === 'undefined' || !window.localStorage) {
            return false
        }
        
        // Modifica a key se estiver em desenvolvimento
        if (process.env.NODE_ENV === "development") {
            key = `${process.env.NODE_ENV}:${key}`
        }
        
        window.localStorage.removeItem(key)
        return true
        
    } catch (error) {
        return false
    }
}
export function showSnackBar(message, bg = "danger", timeout = 5000) {
    const snackbar = document.getElementById("awesome-snackbar")
    snackbar.classList.add("show")
    snackbar.classList.add(`bg-${bg}`)
    snackbar.classList.add("text-white")
    snackbar.classList.add("text-center")
    snackbar.innerText = message

    setTimeout(() => {
        snackbar.classList.remove("show")
        snackbar.classList.remove(`bg-${bg}`)
        snackbar.classList.remove("text-white")
        snackbar.classList.remove("text-center")
        snackbar.innerText = ""
    }, timeout)
}
export function getBranchUserData() {
    let branch = window.localStorage.getItem("easygestorweb_current_branch")
    if (branch) {
        branch = JSON.parse(branch)

        if (branch.is_fake) {
            try {
                let user = window.localStorage.getItem("easygestorweb_userdata")
                user = JSON.parse(user)
                return `Email: ${user.email} (Sem empresa)`
            } catch (error) {
                return ""
            }
        }

        let cpfCnpj = ''
        let name = ''
        if (branch.company) {
            name = branch.company.fancy_name
            cpfCnpj = branch.company.cnpj
        } else {
            cpfCnpj = branch.individual.cpf
            name = branch.name
        }
        cpfCnpj = formatDocument(cpfCnpj)
        return `Nome: ${name} - CPF/CNPJ: ${cpfCnpj} - Email: ${branch.email}`
    } else {
        try {
            let user = window.localStorage.getItem("easygestorweb_userdata")
        user = JSON.parse(user)
        return `Email: ${user.email} (Sem empresa)`
        } catch (error) {
            return ""
        }
    }
} ''


export function DifferenceBetweenDatesInDays(date1, date2 = new Date()) {
    let difference = date1.getTime() - date2.getTime();
    difference = Math.ceil(difference / (1000 * 3600 * 24));

    return difference
}

export function parseQueryString(qs) {
    let params = {}
    for (let x of qs.split("&")) {
        const [k, v] = x.split("=")
        params[k] = v
    }
    return params
}

export function CutieflyCheckVersion(){
    const storagedVersion = getCookieByName("cutiefly")
    const currentVersion = process.env.REACT_APP_BUILD_VERSION
    if (!storagedVersion) {
        setCookieByName("cutiefly", currentVersion)
    } else {
        if (storagedVersion !== currentVersion) {
            const cookies = {}
            const storages = {}
            for(let cookie of ["branch_owner_id", "branch_owner_name", "branch_state_name", "role", "access", "refresh", "username", "branch_count"]){
                cookies[cookie] = getCookieByName(cookie)
            }
            clearAllCookies()
            for(let cookie of Object.keys(cookies)){
                setCookieByName(cookie, cookies[cookie])
            }
            for(let storage of ["easygestorweb_current_branch", "easygestorweb_refresh_token", "easygestorweb_apikey", "easygestorweb_userdata"]){
                storages[storage] = localStorage.getItem(storage)
            }
            localStorage.clear()
            for(let storage of Object.keys(storages)){
                localStorage.setItem(storage, storages[storage])
            }
            window.location.reload(true)
        }
    }
}

export function exportCSVData(filename="", header="", data=""){
    data = [].concat([header]).concat(data)
    filename = `${filename}.csv`
    console.debug(filename)
    console.debug(data)
    const csvContent = data.map(row => row.join(',')).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv' });
    if (navigator.msSaveBlob) {
        // Para o Internet Explorer
        navigator.msSaveBlob(blob, filename);
      } else {
        const link = document.createElement('a');
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', filename);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
}
export function formateCurrentDate(){
    const now = new Date()
    const year = now.getFullYear()
    const month = String(now.getMonth() + 1).padStart(2, '0')
    const day = String(now.getDate()).padStart(2, '0')

    return `${year}-${month}-${day}`
}


export function callSupport(text=""){
    window.open( `https://api.whatsapp.com/send/?phone=11966466526&text=${text}` )

}
export function increaseMonths(date, months) {
    let dates = [new Date(date)];
    let currentDate = new Date(date);
    let originalDay = date.getDate();
    let isEndOfMonth = originalDay === new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();

    for (let i = 1; i < months; i++) {
        const nextMonth = currentDate.getMonth() + 1;
        const nextYear = currentDate.getFullYear() + Math.floor(nextMonth / 12);
        const lastDayOfNextMonth = new Date(nextYear, (nextMonth % 12) + 1, 0).getDate();

        let newDay = isEndOfMonth ? lastDayOfNextMonth : Math.min(originalDay, lastDayOfNextMonth);
        const newDate = new Date(nextYear, nextMonth % 12, newDay);

        dates.push(newDate);
        currentDate = newDate;
        isEndOfMonth = newDay === lastDayOfNextMonth;
    }

    return dates;
}

export function downloadCSV(filename, headers, rows) {
    const delimiter = ';';
    const escapeCSV = (val) => {
        if (val === null || val === undefined) return '';
        const s = String(val);
        const needsQuote = new RegExp(`[\\"${delimiter}\\r\\n]`).test(s);
        const escaped = s.replace(/"/g, '""');
        return needsQuote ? `"${escaped}"` : escaped;
    };

    const csvContent = '\uFEFF' + [headers, ...rows]
        .map(r => r.map(escapeCSV).join(delimiter))
        .join('\r\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}



// WEBPACK FOOTER //
// ./src/utils/index.js